import {routeTo} from '@/utils/router'

export const useErrorContent = (statusCode: number) => ({
  title: `error-page.${statusCode}-title`,
  linkText: 'error-page.return-to-homepage-text',
  linkHref: routeTo.home(),
})
